import moment from "moment";
import { Button, Card, Row, Col } from "antd";
import { Flex } from "@chakra-ui/layout";
import {
  MdConfirmationNumber,
  MdNoteAlt,
  MdCheckCircle,
  MdGroups,
  MdBuild,
  MdEvent,
} from "react-icons/md";
import useStore from "../hooks/useStore";
import { StyledModal } from "./styles";
import { usePrinter } from "../hooks/useCreateOrdemServico";
import { useState } from "react";

interface ModalResultadoProps {
  numeroOs: any;
  talhoesIds: any[];
  isOpen: boolean;
  onClose: () => void;
}

function ModalResultado({ numeroOs, talhoesIds, isOpen, onClose }: ModalResultadoProps) {
  const [loading, setLoading] = useState(false);
  const {
    equipeNome,
    observacoes,
    operacaoNome,
    previsaoInicio,
    previsaoEncerramento,
    classesOperacoes
  } = useStore();

  const { mutateAsync: exportShedule } = usePrinter();

  async function handlePrinter() {
    try {
      const ordemServicoId = numeroOs?.ordemServicoId;
      setLoading(true);
  
      const blob = await exportShedule(ordemServicoId);
  
      const url = URL.createObjectURL(blob);
  
      const link = document.createElement("a");
      link.href = url;
      link.download = "arquivo.pdf";
      // link.click();

      window.open(url, "_blank");

      setTimeout(() => {
          URL.revokeObjectURL(url);
      }, 1000);

      setLoading(false);

    } catch(e) {
      setLoading(false);
    }
  }

  return (
    <StyledModal
      centered
      width={750}
      zIndex={999999}
      visible={isOpen}
      onCancel={onClose}
      footer={
        <Flex justifyContent="center">
          <Button
            size="large"
            type="primary"
            onClick={onClose}
            style={{ borderRadius: 10, backgroundColor: "#4caf50", border: "none" }}
          >Concluir</Button>
          <Button
            size="large"
            type="default"
            onClick={handlePrinter}
            disabled={!numeroOs?.ordemServicoId}
            style={{ borderRadius: 10}}
          >{loading ? "Imprimindo..." : "Imprimir"}</Button>
    
        </Flex>
      }
    >
      <Flex direction="column" align="center" gridGap={1} marginBottom={4}>
        <MdCheckCircle size={72} color="#2e7d32" />
        <h1 style={{ fontWeight: "bold", color: "#2e7d32", fontSize: 22 }}>Ordem de Serviço Criada!</h1>
        <p>Integração com GeoAgrícola concluída</p>
      </Flex>

      <Card style={{ margin: "8px 0", borderRadius: 10, borderLeft: "4px solid #4caf50", backgroundColor: "#f1f8f4" }}>
        <Flex align="center" gridGap={2}>
          <MdConfirmationNumber size={22} color="#4caf50" />
          <b style={{ color: "#777" }}>NÚMERO DA OS</b>
        </Flex>
        <b style={{ fontSize: 22, color: "#2e7d32" }}>{numeroOs?.numero ?? "-"}</b>
      </Card>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Card style={{ borderRadius: 10, backgroundColor: "#f8f9fa", border: "none" }}>
            <Flex align="center" gridGap={2} marginBottom={2}>
              <MdGroups size={22} color="#777" />
              <b style={{ color: "#777" }}>EQUIPE</b>
            </Flex>
            <p style={{ fontSize: 16 }}>{equipeNome ?? "-"}</p>
          </Card>
        </Col>
        <Col span={12}>
          <Card style={{ borderRadius: 10, backgroundColor: "#f8f9fa", border: "none" }}>
            <Flex align="center" gridGap={2} marginBottom={2}>
              <MdBuild size={22} color="#777" />
              <b style={{ color: "#777" }}>OPERAÇÃO</b>
            </Flex>
            <p style={{ fontSize: 16 }}>{operacaoNome ?? "-"}</p>
          </Card>
        </Col>
        <Col span={24}>
          <Card style={{ borderRadius: 10, backgroundColor: "#f8f9fa", border: "none" }}>
            <Flex align="center" gridGap={2} marginBottom={2}>
              <MdEvent size={22} color="#777" />
              <b style={{ color: "#777" }}>PERÍODO DE EXECUÇÃO</b>
            </Flex>
            <p style={{ fontSize: 16 }}>
              <b>{moment(previsaoInicio).format("DD/MM/YYYY")}</b> até <b>{moment(previsaoEncerramento).format("DD/MM/YYYY")}</b>
            </p>
          </Card>
        </Col>
      </Row>

      <Card style={{ margin: "8px 0", borderRadius: 10, backgroundColor: "#e3f2fd", border: "none" }}>
        <Flex gridGap={4}>
          <div style={{ textAlign: "center" }}>
            <b style={{ fontSize: 24, color: "#1976d2" }}>{talhoesIds.length ?? 0}</b>
            <p style={{ color: "#777" }}>TALHÕES</p>
          </div>
          <div style={{ width: 1, height: 60, backgroundColor: "#90caf9" }}></div>
          <div style={{ textAlign: "center" }}>
            <b style={{ fontSize: 24, color: "#1976d2" }}>{classesOperacoes.length ?? 0}</b>
            <p style={{ color: "#777" }}>OPERAÇÕES</p>
          </div>
        </Flex>
      </Card>

      {observacoes && (
        <Card style={{ borderRadius: 10, backgroundColor: "#fff8e1", borderLeft: "4px solid #ffc107" }}>
          <Flex align="center" gridGap={2} marginBottom={2}>
            <MdNoteAlt size={22} color="#f57c00" />
            <b>OBSERVAÇÕES</b>
          </Flex>
          <p>{observacoes ?? "-"}</p>
        </Card>
      )}
    </StyledModal>
  );
}

export default ModalResultado;
